export default __webpack_public_path__ + "static/media/blog.793078b7.webp";